import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";
const stepper_theme = {
    NETWELL: {
        count_step_bg_done: "#a9c43b",
        count_step_bg_inprogress: "#f2b543",
        count_step_bg_disabled: "rgba(0, 0, 0, 0.38)",
        backgroundColor: "#f6f5ec",
        fontColor: "#fff",
    },
};
const StepperHStyle = styled(Box)(({ theme, style }) => {
    console.log(stepper_theme);
    return {
        "&.NETWELL-stepperH-wrapper": {
            ".stepperH_stepper": {
                backgroundColor: stepper_theme.NETWELL.backgroundColor,
                padding: 24,
            },
            ".stepperH_button": {
                ".Mui-disabled svg": {
                    color: stepper_theme.NETWELL.count_step_bg_disabled,
                },
                "&.stepperH_button-completed": {
                    svg: {
                        color: stepper_theme.NETWELL.count_step_bg_done,
                    },
                },
                "&.stepperH_button-inprogress": {
                    svg: {
                        color: stepper_theme.NETWELL.count_step_bg_inprogress,
                    },
                },
            },
            "#stepperH_stepper-Dcomponent": {
                minHeight: "50vh",
            },
            // Responsive
            [theme.breakpoints.down("sm")]: {
                maxHeight: 160,
                overflow: "scroll",
            },
        },
    };
});
export default StepperHStyle;
